import React from 'react';
import { Form } from 'semantic-ui-react';

import Radio, { RadioGroupProps } from 'src/components/custom/Radio';

export type Props = {
  label?: string;
  id?: string;
  value?: string | number | (string | number)[];
  error?: string;
  name?: string;
  extra?: React.ReactNode;
} & RadioGroupProps;

const FeedbackField: React.FC<Props> = (props) => {
  const { error, label, extra, ...rest } = props;

  return (
    <Form.Field className="my-100" error={!!error}>
      <label>{label}</label>

      <div className="d-flex-between space-x-24 width-lg-3 width-md-3 width-sm-4 margin-center">
        <span className="flex-shrink-0">Not useful</span>
        <Radio.HorizontalGroup {...rest} />
        <span className="flex-shrink-0">Very useful</span>
      </div>
      {extra && <div>{extra}</div>}
      {error && <div className="ui pointing above prompt label">{error}</div>}
    </Form.Field>
  );
};

export default FeedbackField;
